<template>
    <div>
        <ul class="public-list" v-if="params.type=='sol'">
            <!-- type=sol 方案列表 -->
            <li class="sol-list-item" v-for="(item,index) in params.list" :key="index">
            <!-- 方案热搜列表 -->
            <div class="hot-search" v-if="params.isHotSearch" @click="jumpDetail(item)">
                <div class="hot-search-left">
                    <div class="item-title"><span>{{index+1}}</span>{{item.solutionName | textSlice(28)}}</div>
                    <div class="item-content">{{item.description | textSlice(30)}}</div>
                    <div class="item-count"><span>{{item.pageView | myriabit}}</span>阅读量</div>
                    </div>
                    <div class="hot-search-right">
                    <img :src="item.matchPic | getImageUrl">
                </div>
            </div>
            </li>
        </ul>
        <!-- 方案列表 -->
        <div class="all-solutions">
            <div class="public-header anchor">
                <div class="public-header-left">全部方案</div>
            </div>
            <div v-show="!noData && solutions.length > 0">
                <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    :offset="80"
                    @load="onLoad"
                >
                    <div class="list-content">
                        <van-row class="list-item" v-for="(item, index) of solutions" :key="index">
                            <router-link :to="`/solutions/detail/${item.solutionId}.html?buildingType=${buildingType}&buildingTypeId=${buildingTypeId}&firstSysAttr=${firstSysAttr}&firstSysAttrId=${firstSysAttrId}`">
                            <van-col :span="24">
                                <van-row  class="list-item-title">
                                    <div> {{item.solutionName}}</div>
                                </van-row>
                                <van-row class="list-item-count">
                                    <van-col :span="12">
                                      <van-icon name="contact" v-if="item.nickName || item.userName" /> {{ item.nickName }}{{ !item.nickName && item.userName }}
                                    </van-col>
                                    <van-col :span="12" style="text-align:right">
                                    <span>{{item.pageView | myriabit}}</span>&nbsp;阅读量
                                    </van-col>
                                </van-row>
                            </van-col>
                            </router-link>
                        </van-row>
                    </div>
                </van-list>
            </div>
            <noResult v-show="noData && solutions.length <= 0" :noResultData="noResultData" @toListSelf="toListSelf"></noResult>
        </div>
    </div>
</template>

<script>
import { textSlice, myriabit, getImageUrl } from '@/filters/commonFilters'
import noResult from '@/components/noResult'
export default {
  name: 'list',
  props: ['params'],
  filters: {
    textSlice,
    myriabit,
    getImageUrl
  },
  components: { noResult },
  data () {
    return {
      loading: false,
      finished: false,
      paramsData: {
        page: 1,
        pageSize: 10,
        brandId: '',
        buildingType: '',
        firstSysAttr: ''
      },
      solutions: [],
      noData: false,
      noResultData: {
        typeName: '方案',
        callback: 'callback'
      },
      buildingType: '',
      buildingTypeId: '',
      firstSysAttr: '',
      firstSysAttrId: ''
    }
  },
  created () {
    this.$store.dispatch('BASE_DATA_GET_BRANDS')
    this.$store.dispatch('BASE_DATA_GET_COMMONDATA', 5)
    this.$store.dispatch('BASE_DATA_GET_COMMONDATA', 6)
    this.$store.dispatch('SOLUTIONS_GET_KEYWORD')
    // 建筑业态
    if (this.$route.query.buildingType) {
      this.paramsData['buildType'] = this.$route.query.buildingTypeId
      this.buildingType = this.$route.query.buildingType
      this.buildingTypeId = this.$route.query.buildingTypeId
    }
    // 系统属性
    if (this.$route.query.firstSysAttr) {
      this.paramsData['firstSysAttr'] = this.$route.query.firstSysAttrId
      this.firstSysAttr = this.$route.query.firstSysAttr
      this.firstSysAttrId = this.$route.query.firstSysAttrId
    }
    this.getData()
  },
  methods: {
    // 方案详情
    jumpDetail (item) {
      this.$router.push(`/solutions/detail/${item.solutionId}.html`)
    },
    // 资讯详情
    toNewsDetail (id) {
      this.$router.push(`/news/detail/${id}.html`)
    },
    onLoad () {
      // 调用查询接口
      let self = this
      this.paramsData.page++
      this.$store.dispatch('SOLUTIONS_GET_LIST', this.paramsData).then(result => {
        if (result && result.status === 200 && result.data && result.data.data && result.data.data.solutions && result.data.data.solutions.length > 0) {
          self.solutions = self.solutions.concat(result.data.data.solutions)
          self.paramsData.page = result.data.data.page.page
          window.setTimeout(() => {
            self.loading = false
            if (result.data.data.page >= result.data.data.pages) {
              self.finished = true
            }
          }, 1000)
        } else {
          self.loading = false
          self.finished = true
        }
      })
    },
    getData () {
      if (!this.paramsData.firstSysAttr || this.paramsData.firstSysAttr === '') {
        delete this.paramsData.firstSysAttr
      }
      if (!this.paramsData.buildingType || this.paramsData.buildingType === '') {
        delete this.paramsData.buildingType
      }
      if (!delete this.paramsData.brandId || delete this.paramsData.brandId === '') {
        delete delete this.paramsData.brandId
      }
      this.paramsData.page = 0
      this.paramsData.pageSize = 10
      this.finished = false
      this.noData = false
      this.onLoad()
    },
    toListSelf () {
      delete this.paramsData.firstSysAttr
      delete this.paramsData.buildingType
      delete this.paramsData.brandId
      this.getData()
    }
  }
}
</script>

<style scoped lang="scss">

  @mixin TwoLine {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .public-list {
    margin-bottom: 10px;
    background-color: #fff;
    .sol-list-item {
      padding: 15px 0;
      margin: 0 15px;
      border-bottom: 1px solid #d8d8d8;
      .hot-search {
        display: flex;
        justify-content: space-between;
        &-left {
          width: 220px;
          flex: 0 0 auto;
          .item-title {
            font-size: 14px;
            white-space: normal;
            span {
              display: inline-block;
              width: 15px;
              height: 15px;
              line-height: 16px;
              text-align: center;
              color: #fff;
              font-size: 12px;
              background: #a0a0a0;
              border-radius: 2px;
              margin-right: 4px;
              vertical-align: 1px;
            }
          }
          .item-content {
            font-size: 13px;
            color: #999;
            margin-top: 5px;
          }
          .item-count {
            margin-top: 5px;
            color: #a0a0a0;
            font-size: 10px;
            span {
              color: #f8a325;
              margin-right: 3px;
            }
          }
        }
        &-right {
          width: 110px;
          height: 75px;
          flex: 0 0 auto;
          margin-left: 15px;
          img {
            width: 100%;
            height: 100%;
            vertical-align: middle;
          }
        }
      }
      &:first-child .hot-search-left .item-title span {
        background: #f25050;
      }
      &:nth-child(2) .hot-search-left .item-title span {
        background: #faa528;
      }
      &:nth-child(3) .hot-search-left .item-title span {
        background: #9cbb2e;
      }
      .sol-public {
        display: flex;
        justify-content: space-between;
        color: #222;
        &-left {
          width: 240px;
          flex: 0 0 auto;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .info-label {
            display: inline-flex;
            outline: 1px solid #1cc0da;
            color: #1cc0da;
            padding: 1px 4px; /* no */
            position: relative;
            margin-right: 6px;
            font-size: 10px;
            align-items: center;
            bottom: 2px;
          }
          .item-count {
            color: #a0a0a0;
            font-size: 10px;
            span {
              color: #f8a325;
              margin-right: 3px;
            }
          }
        }
        &-right {
          width: 90px;
          height: 62px;
          flex: 0 0 auto;
          img {
            width: 100%;
            height: 100%;
            vertical-align: middle;
          }
        }
      }
      &:last-child {
        border-bottom: 0;
      }
    }
  }
  .list-content{
    background-color: white;
    padding-left: 15px;
    padding-right: 15px;
    border-bottom: 1px solid #D8D8D8;
  .list-item{
    border-bottom: 1px solid #D8D8D8;
    padding-top: 15px;
    &:last-child{
        border-bottom: none;
     }
    &-title{
      color: #222222;
      font-size: 14px;
      margin-bottom: 6px;
     img{
       width: 90px;
       height: 61px;
     }
      div{
        height: 40px;
        display: inline-block;
        vertical-align: middle;
        text-overflow: ellipsis;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      & i{
          margin-left: 8px;
          border: 1px solid #1DBFDA;
          position: relative;
          font-size: 10px;
          padding: 0 5px;
          box-sizing: border-box;
          color: #1DBFDA;
          border-top-left-radius: 2px;
          border-top-right-radius: 2px;
          border-bottom-right-radius: 2px;
          font-style: inherit;
          &::before{
             position: absolute;
             left: -5px;
             bottom: -1px;
             content: '';
             width:0;
             border-top:4px solid white;
             border-right:4px solid #1DBFDA;
           }
           &::after{
              position: absolute;
              left: -2px;
              bottom: 0px;
              content: '';
              width:0;
              border-top:2px solid transparent;
              border-right:2px solid white;
            }
        }
    }
     &-describe{
        color: #999999;
        font-size: 13px;
        height: 18px;
        line-height: 18px;
        margin-bottom: 5px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &-count{
        margin-bottom: 15px;
        font-size: 10px;
        color: #a0a0a0;
        height: 14px;
        line-height: 14px;
        & span{
            color: #f8a325;
          }
       }
       .van-icon{
           vertical-align: text-top;
       }
  }
}
.no-data-content{
  background-color: #f5f5f5;
  text-align: center;
  padding-top: 111px;
  .describe-content{
    p{
      font-size: 14px;
      color: #a0a0a0;
      margin: 0px;
    }
  }
  .button-content{
    button{
      margin-top: 40px;
      width: 200px;
      height: 44px;
      background-color: #1dbfda;
      color: white;
      border: none;
      border-radius: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hotLists.vue